import { LocalCommodity as Commodity } from '../../../src/app/classes';

export class SelectCommoditiesData {
  constructor(public title: string, public leftButtonTitle: string, public rightButtonTitle: string, public commodities: Commodity[]) {}
}
